import { Component, DestroyRef, inject, OnInit, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { AuthorizeService } from '../../auth/authorize.service';
import { ProfileRoleConstants } from 'src/app/common/ProfileRole';
import { ExtendedProfile } from '../../common/ExtendedProfile';
import { AppProfileService } from '../../services/profile.service';
import { OrderService } from '../../services/order.service';

/**
 * Renders the "Mein Konto" navigation links (with their role-based visibility
 * and the pending-claims badge). Used both in the avatar dropdown
 * (`variant="dropdown"`) and in the contextual left sidebar
 * (`variant="sidebar"`), so the link list and its access rules live in one place.
 */
@Component({
  imports: [RouterModule],
  selector: 'app-my-account-nav',
  templateUrl: './my-account-nav.component.html',
  styleUrls: ['./my-account-nav.component.css'],
})
export class MyAccountNavComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private profileService = inject(AppProfileService);
  private orderService = inject(OrderService);
  private authorizeService = inject(AuthorizeService);

  readonly variant = input<'sidebar' | 'dropdown'>('sidebar');

  public profile: ExtendedProfile;
  public isAdmin = false;
  public pendingClaims = 0;

  get linkClass(): string {
    return this.variant() === 'dropdown' ? 'dropdown-item' : 'link-dark rounded';
  }

  /**
   * #221: „Passwort ändern" is the IDP's page, not a route of this app — a plain link, so the
   * browser leaves for the IDP and comes back to the page the user was on. Read on every
   * change detection, so the return URL follows the router without a subscription.
   */
  get changePasswordUrl(): string {
    return this.authorizeService.changePasswordUrl(window.location.href);
  }

  ngOnInit(): void {
    this.profileService.currentProfile$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((p) => {
      this.profile = p;
      this.isAdmin = p?.role == ProfileRoleConstants.RoleIdAdmin;
    });
    // Shared by every instance (header dropdown and sidebar) — see OrderService.pendingClaimsCount$.
    this.orderService.pendingClaimsCount$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((count) => {
      this.pendingClaims = count;
    });
  }
}
